// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  border: 1px solid var(--ion-item-border-color);
}

ion-modal {
  --width: 290px;
  --height: 400px;
  --border-radius: 10px;
}

.ion-checkbox {
  --border-color: #C6C6C6;
  --border-color-checked: var(--ion-color-primary);
  --border-radius: 5px;
  --size: 26px;
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/admin/tasks/create/create.page.scss"],"names":[],"mappings":"AAAA;EACI,8CAAA;AACJ;;AACA;EACI,cAAA;EACA,eAAA;EACA,qBAAA;AAEJ;;AACA;EACI,uBAAA;EACA,gDAAA;EACA,oBAAA;EACA,YAAA;EACA,kBAAA;AAEJ","sourcesContent":["ion-item {\n    border: 1px solid var(--ion-item-border-color);\n}\nion-modal {\n    --width: 290px;\n    --height: 400px;\n    --border-radius: 10px;\n}\n\n.ion-checkbox {\n    --border-color: #C6C6C6;\n    --border-color-checked: var(--ion-color-primary);\n    --border-radius: 5px;\n    --size: 26px;\n    margin-right: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
